import React from 'react'
import { useRecoilState } from 'recoil'
import { pageState } from '../../../../../src/atoms/PageAtom'
import { pastPageState } from '../../../../../src/atoms/PastPageAtom'

type Props = {
  image: string
  title: string
  uri: string
}

function HomeSlide(props: Props) {
  const [, setPage] = useRecoilState(pageState)
  const [, setPastPage] = useRecoilState(pastPageState)

  const isOuterUri = (): boolean => {
    if (!props.uri) return false

    return props.uri.indexOf('http') !== -1
  }
  const pageJump = () => {
    if (!props.uri) return

    setPastPage('home')
    setPage(props.uri)
  }

  return (
    <div className="slide-outer">
      {isOuterUri() ? (
        <a
          className="slide-inner"
          style={{ backgroundImage: `url(${props.image})` }}
          aria-label={props.title}
          href={props.uri}
          target="_blank"
          rel="nofollow noopener noreferrer"
        ></a>
      ) : (
        <button
          className="slide-inner"
          style={{ backgroundImage: `url(${props.image})` }}
          aria-label={props.title}
          onClick={() => pageJump()}
        ></button>
      )}
    </div>
  )
}

export default HomeSlide
